// extracted by mini-css-extract-plugin
export default {"joining":"rq-m2x","joiningContainer":"_2P4Cvw","loadingIndicator":"_2RP1uY","modalTitle":"_1U_iww","modalMsg":"_25f_aq","placeholder":"_1XfW2p","returnToCommunityButton":"_1YlEiP"};